import React from "react";
import { Modal } from "antd";
import { Download } from "lucide-react";
import { Button } from "./ui/button";

const SDKDownloadModal = ({ visible, onClose, onDownload }) => {
  return (
    <Modal
      title="下载SDK"
      open={visible}
      onCancel={onClose}
      footer={null}
      width={500}
    >
      <div className="space-y-4">
        <p className="text-gray-600">请选择您需要的SDK版本：</p>
        <div className="grid grid-cols-1 gap-4">
          <Button
            variant="blue-griadient"
            size="lg"
            onClick={() => onDownload("Linux")}
            className="justify-center"
          >
            <Download className="mr-2 h-5 w-5" />
            Linux版本
          </Button>
          <Button
            variant="secondary"
            size="lg"
            onClick={() => onDownload("Windows")}
            disabled
            className="justify-center"
          >
            <Download className="mr-2 h-5 w-5" />
            Windows版本 (敬请期待)
          </Button>
          <Button
            variant="secondary"
            size="lg"
            onClick={() => onDownload("macOS")}
            disabled
            className="justify-center"
          >
            <Download className="mr-2 h-5 w-5" />
            macOS版本 (敬请期待)
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default SDKDownloadModal;
